var _DomainActionsErrorsM, _DomainActionsErrorsM2, _DomainActionsErrorsM3;
import { Box } from '@wix/design-system';
import { DomainActionsErrorsMap, DomainSearchSuiteModule, SearchRecommendationModule } from '@wix/domains-search-suite';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import clsx from 'clsx';
import React from 'react';
import { GeneralAnonymousOverride, SubdomainRootTaken } from '../../../Components';
import { AnonymousFooter } from '../../../Components/AnonymousFooter/AnonymousFooter';
import { AnonymousResultsHeader } from '../../../Components/Headers';
import { BackButton } from '../../../Components/Headers/HeaderWrapper';
import { AnonymousVoucherBanner } from '../../../Components/VoucherBanner';
import { WIX_HEADER_HEIGHT } from '@wix/core-domain-search';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { useIsWixHpReferral } from '../../../hooks/useIsWixHpReferral';
import { useRecommendations } from '../../../hooks/useRecommendations';
import { useResultsBack } from '../../../hooks/useResultsBack';
import { useResultsPageConfig } from '../../../hooks/useResultsPageConfig';
import { useSettledMethods } from '../../../hooks/useSettledMethod';
import { ANONYMOUS_SETTLEMENTS } from '../../../utils/anonymousSettlements';
import { ResultsLayout, ResultsRecommendations, ResultsSearchBar, V4_CONTENT_MAX_WIDTH } from '../../ResultsLayout';
import s from '../../anonymousResultsPage.scss';
const SCROLL_TARGET_DATA_HOOK = 'anonymous-results-scroll-target';
const customConfiguration = {
  ...(((_DomainActionsErrorsM = DomainActionsErrorsMap.connect) == null ? void 0 : _DomainActionsErrorsM.reduce((acc, status) => ({
    ...acc,
    [status]: GeneralAnonymousOverride
  }), {})) ?? {}),
  ...(((_DomainActionsErrorsM2 = DomainActionsErrorsMap.assign) == null ? void 0 : _DomainActionsErrorsM2.reduce((acc, status) => ({
    ...acc,
    [status]: GeneralAnonymousOverride
  }), {})) ?? {}),
  ...(((_DomainActionsErrorsM3 = DomainActionsErrorsMap.transfer) == null ? void 0 : _DomainActionsErrorsM3.reduce((acc, status) => ({
    ...acc,
    [status]: GeneralAnonymousOverride
  }), {})) ?? {}),
  transfer: GeneralAnonymousOverride,
  connect: GeneralAnonymousOverride,
  subdomainRootIsNotConnected: SubdomainRootTaken,
  domainTakenInWix: GeneralAnonymousOverride,
  subdomainTakenInWix: SubdomainRootTaken,
  noStatus: GeneralAnonymousOverride
};
export const AnonymousResultsPage = _ref => {
  let handlers = _ref.handlers,
    externalViewer = _ref.externalViewer,
    deviceType = _ref.deviceType,
    showCartHeader = _ref.showCartHeader;
  useSettledMethods(ANONYMOUS_SETTLEMENTS);
  const isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement(DomainsApiClient.Provider, null, /*#__PURE__*/React.createElement(DomainSearchSuiteModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    actions: {
      siteInfo: {
        externalViewer: Boolean(externalViewer)
      },
      handlers,
      resolveCorrectedDomains: isMobile
    },
    statusesCustomComponents: {
      customConfiguration
    }
  }, /*#__PURE__*/React.createElement(AnonymousResultsPageContent, {
    deviceType: deviceType,
    showCartHeader: showCartHeader
  })));
};
export const AnonymousResultsPageContent = _ref2 => {
  let deviceType = _ref2.deviceType,
    _ref2$showCartHeader = _ref2.showCartHeader,
    showCartHeader = _ref2$showCartHeader === void 0 ? false : _ref2$showCartHeader;
  const isMobile = useIsMobile();
  const isWixHpReferral = useIsWixHpReferral();
  const isWixHpMobile = isMobile && isWixHpReferral;
  const handleBackClick = useResultsBack();
  const _useResultsPageConfig = useResultsPageConfig(),
    isV41 = _useResultsPageConfig.isV41,
    isV41Desktop = _useResultsPageConfig.isV41Desktop,
    isOptimized = _useResultsPageConfig.isOptimized;
  const contentClassName = clsx(s.centeredContent, isOptimized && s.narrowContent);
  const _useRecommendations = useRecommendations({
      enableOnEmptyQuery: false
    }),
    taxesNotIncluded = _useRecommendations.taxesNotIncluded,
    query = _useRecommendations.query;
  const showsPageHeader = !isOptimized || isWixHpMobile && !query;
  return /*#__PURE__*/React.createElement(ResultsLayout, {
    dataHook: SCROLL_TARGET_DATA_HOOK,
    biViewMode: "Storefront",
    querySubmitPath: "/",
    deviceType: deviceType,
    showCartHeader: showCartHeader,
    hideSearchBarShadowOnPartialMatch: true,
    showSearchIcon: true,
    hideFilterChips: true,
    useCompactRecommendationsLayout: true,
    headerTop: isV41Desktop ? WIX_HEADER_HEIGHT : undefined,
    headerPadding: isV41Desktop ? '0 48px 32px' : undefined,
    headerGap: isV41Desktop ? '24px' : undefined,
    headerMargin: isMobile ? '0' : undefined,
    desktopGridGap: isV41 ? '0' : undefined,
    voucherPlacement: isV41Desktop ? 'stickyHeader' : 'outsideStickyHeader',
    voucherMaxWidth: isV41 ? V4_CONTENT_MAX_WIDTH : undefined,
    mobileVoucherInSearchBar: true,
    optimizedSearchBarStyle: !isV41,
    searchBar: /*#__PURE__*/React.createElement(ResultsSearchBar, {
      isWixHpMobile: isWixHpMobile,
      compactLayouts: isOptimized,
      scrollIntoView: {
        dataHook: SCROLL_TARGET_DATA_HOOK,
        scrollMarginTop: WIX_HEADER_HEIGHT
      }
    }),
    header: showsPageHeader ? /*#__PURE__*/React.createElement(AnonymousResultsHeader, {
      onBackClick: isMobile ? undefined : handleBackClick,
      hideTrustBuilders: true
    }) : undefined,
    voucher: /*#__PURE__*/React.createElement(AnonymousVoucherBanner, {
      optimizedVoucherCopy: true
    }),
    footer: /*#__PURE__*/React.createElement(Box, {
      gridArea: "footer",
      padding: "SP6 48px",
      className: contentClassName,
      textAlign: "center",
      align: "center"
    }, /*#__PURE__*/React.createElement(AnonymousFooter, {
      taxesNotIncluded: taxesNotIncluded
    })),
    mobileBackButton: isOptimized || isWixHpMobile ? undefined : /*#__PURE__*/React.createElement(Box, {
      width: "100%"
    }, /*#__PURE__*/React.createElement(BackButton, {
      onClick: handleBackClick
    }))
  }, /*#__PURE__*/React.createElement(SearchRecommendationModule.Provider, null, /*#__PURE__*/React.createElement(ResultsRecommendations, {
    showHeroCard: true,
    className: contentClassName,
    emptyState: isWixHpMobile ? /*#__PURE__*/React.createElement(React.Fragment, null) : undefined,
    titleOverflowStrategy: isOptimized ? 'scale' : 'ellipsis',
    rowTitleOverflowStrategy: isMobile ? 'wrap' : undefined,
    clickableRows: isOptimized,
    clickableLeadingCard: !isV41Desktop,
    compactPriceLabel: isMobile,
    stackedMobileCards: true,
    desktopContentPadding: isV41 ? '24px' : undefined,
    desktopContentGap: isV41 ? '24px' : undefined,
    insightsPaddingTop: isV41 ? '24px' : undefined,
    alternativesHeadingGap: isV41Desktop ? '24px' : undefined
  })));
};
//# sourceMappingURL=AnonymousResultsPage.js.map